import './FloatingContact.css'
import zaloIcon from '../../assets/icons/Icon_of_Zalo.png'
import facebookIcon from '../../assets/icons/Facebook_Logo_.png'

const FloatingContact = () => {
  return (
    <div className="floating-contact" id="floating-contact">
      {/* Zalo Button */}
      <a 
        href="https://zalo.me/0979808278" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="floating-btn zalo"
        aria-label="Chat Zalo"
        id="floating-zalo"
      >
        <span className="pulse-ring"></span>
        <img src={zaloIcon} alt="Zalo Logo" />
      </a>

      {/* Facebook Button */}
      <a 
        href="https://www.facebook.com/maxhome.chuyengiathicongtrongoi" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="floating-btn facebook"
        aria-label="Chat Facebook"
        id="floating-facebook"
      >
        <span className="pulse-ring"></span>
        <img src={facebookIcon} alt="Facebook Logo" />
      </a>
    </div>
  )
}

export default FloatingContact
